import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  Layers, Users, Building2, BarChart2, 
  FileText, LayoutDashboard, ShieldCheck 
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = () => {
  const { user } = useAuth();
  
  // Definición base de todos los módulos posibles con sus IDs de permiso
  const allNavItems = [
    { id: 'dashboard', name: 'Dashboard', path: '/dashboard', icon: LayoutDashboard },
    { id: 'procesos', name: 'Procesos', path: '/procesos', icon: Layers },
    { id: 'candidatos', name: 'Candidatos', path: '/candidatos', icon: Users },
    { id: 'clientes', name: 'Clientes', path: '/clientes', icon: Building2 },
    { id: 'cotizaciones', name: 'Cotizaciones', path: '/cotizaciones', icon: FileText },
    { id: 'reportes', name: 'Reportes', path: '/reportes', icon: BarChart2 },
    { id: 'usuarios', name: 'Usuarios', path: '/usuarios', icon: ShieldCheck },
  ];

  // Filtrar módulos según los permisos del usuario actual
  // Si no tiene el campo permisos (usuario antiguo), mostramos Dashboard y Procesos por defecto
  const userPermisos = user?.permisos || ['dashboard', 'procesos'];
  
  const navItems = allNavItems.filter(item => userPermisos.includes(item.id));

  return (
    <div className="w-64 bg-[#2C3E4C] text-white flex flex-col h-full shadow-lg fixed left-0 top-0">
      {/* Brand Header - Dinámico */}
      <div className="h-20 flex items-center px-6 bg-white shadow-md border-b border-gray-100">
        <div className="flex items-center gap-3">
          {user?.cliente?.logo_url ? (
            <img 
              src={user.cliente.logo_url} 
              alt={user.cliente.nombre} 
              className="h-10 w-auto max-w-[140px] object-contain"
            />
          ) : (
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-[#2C4F1A] flex items-center justify-center shadow-lg">
                 <ShieldCheck className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-lg tracking-tight text-[#2C4F1A]">HUNTER+</span>
            </div>
          )}
        </div>
      </div>

      {/* Navigation - Filtrada dinámicamente */}
      <nav className="flex-1 py-6 flex flex-col gap-1 px-3 overflow-y-auto">
        {navItems.length > 0 ? navItems.map((item) => (
          <NavLink
            key={item.id}
            to={item.path}
            className={({ isActive }) => 
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                isActive 
                  ? 'bg-[#1E2B36] text-white border-l-4 border-[#2C4F1A] shadow-inner' 
                  : 'text-gray-400 hover:bg-[#1E2B36] hover:text-white'
              }`
            }
          >
            <item.icon size={18} />
            <span className="text-sm font-semibold">{item.name}</span>
          </NavLink>
        )) : (
          <p className="text-xs text-center text-gray-500 mt-10 px-4 italic">
            No tienes módulos activos. Contacta al administrador.
          </p>
        )}
      </nav>

      {/* Footer User Info */}
      <div className="p-4 flex items-center gap-3 border-t border-gray-700 mx-3 mb-2">
        <div className="w-8 h-8 rounded-full bg-[#2C4F1A]/20 flex items-center justify-center text-[#2C4F1A] font-bold text-xs">
          {user?.nombre?.[0] || 'HP'}
        </div>
        <div className="text-xs overflow-hidden">
          <p className="text-gray-300 font-bold truncate">{user?.nombre || 'Usuario'}</p>
          <p className="text-gray-500 text-[10px] uppercase tracking-tighter">{user?.rol}</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
